import { Plus } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { cn } from '@/lib/utils.ts';

interface AddTagAffordanceProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Napis obok kółka. Bez niego zostaje sam znaczek z dymkiem — tak wygląda
   * pusta komórka tabeli, gdzie zdanie krzyczałoby głośniej niż nazwy obok.
   */
  label?: string;
}

/**
 * Zaproszenie do dodania tagów: kreskowane kółko z plusem. Nie jest przyciskiem
 * — wywołanie samo decyduje, w co je opakuje (komórka tabeli robi z całego
 * wiersza jeden przycisk).
 */
const AddTagAffordance = ({
  label,
  className,
  ...props
}: AddTagAffordanceProps) => {
  const mark = (
    <span className="inline-flex size-5 shrink-0 items-center justify-center rounded-full border border-dashed border-neutral-300">
      <Plus className="size-3 text-neutral-400" aria-hidden />
    </span>
  );

  if (!label) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={className} {...props}>
            {mark}
          </span>
        </TooltipTrigger>
        <TooltipContent>Dodaj tagi</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <span
      className={cn('inline-flex items-center gap-1.5', className)}
      {...props}
    >
      {mark}
      <span className="text-xs text-neutral-500">{label}</span>
    </span>
  );
};

export default AddTagAffordance;
